import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { NgxSpinnerModule } from 'ngx-spinner';

import { AppRoutingModule } from './app-routing.module';

/* Components */
import { AppComponent } from './app.component';
import { PublicLayoutComponent } from './shared/components/layouts/public/public-layout.component';
import { PrivateLayoutComponent } from './shared/components/layouts/private/private-layout.component';

/* Modules */
import { SharedComponentModule } from './shared/components/shared-components.module';
import { SharedModule } from './shared/shared.module';

/* Services */
import { AuthService } from '@app/components/authentication/services/auth.service';
import { UserService } from './components/authentication/services/user.service';

/* Interceptors */
import { AuthApiInterceptor } from './components/authentication/interceptors/auth.interceptor';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
// import { ApiInterceptor } from './shared/interceptors/api.interceptor';

@NgModule({
  declarations: [AppComponent, PublicLayoutComponent, PrivateLayoutComponent],
  imports: [BrowserModule, BrowserAnimationsModule, AppRoutingModule, SharedModule, HttpClientModule, NgxSpinnerModule, SharedComponentModule],
  providers: [
    AuthService,
    UserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthApiInterceptor,
      multi: true
    },
    { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-icons' } }
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
